// src/ScrollToTop/ScrollToTop.tsx
import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
var ScrollToTop = ({ forceScroll = false }) => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  useEffect(() => {
    if (forceScroll || navigationType !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [pathname, navigationType, forceScroll]);
  return null;
};
export {
  ScrollToTop
};
//# sourceMappingURL=index.js.map
